import { css } from '@emotion/react'
import { fonts, fontSizes, fontWeights } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const container = css({
  width: 375,
  minHeight: 400,
  fontFamily: fonts.sansSerif,
  backgroundColor: 'white',
  border: `1px solid ${colors.n6.base}`,
  borderRadius: '8px',
})

export const header = css({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '10px 12px',
  gap: '8px',
})

export const avatar = css({
  borderRadius: '50%',
  flexShrink: 0,
})

export const headerInfo = css({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minWidth: 0,
})

export const accountNameStyle = css({
  fontWeight: fontWeights.bold,
  color: 'rgba(0, 0, 0, 0.9)',
  lineHeight: 1.3,
})

export const headerMeta = css({
  fontSize: 12,
  color: 'rgba(0, 0, 0, 0.6)',
  lineHeight: 1.4,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
})

export const contentWrapper = css({
  padding: '0 12px 10px',
})

export const contentTextInputStyle = css({
  fontFamily: fonts.sansSerif,
  fontSize: 14,
  color: 'rgba(0, 0, 0, 0.9)',
  lineHeight: 1.4,
  padding: 0,
  minHeight: 20,
  backgroundColor: 'transparent',

  '.tiptap': {
    padding: 2,
  },

  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },

  '&[data-readonly="true"]:hover': {
    backgroundColor: 'transparent',
  },
})

export const actions = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 12px',
  borderTop: `1px solid ${colors.n6.base}`,
})

export const iconActions = css({
  display: 'flex',
  gap: '16px',
})

export const actionIcon = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  border: 'none',
  cursor: 'default',
  padding: '4px',
  '.lapidary-icon': {
    color: 'rgba(0, 0, 0, 0.6)',
  },
})

export const commentInput = css({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flex: 1,
  marginLeft: '16px',
})

export const commentPlaceholder = css({
  fontSize: fontSizes.small,
  color: colors.n4.base,
})

export const carouselWidth = 375
